// SMR Calculator — loaded via assets/smr-calc.js
document.addEventListener('DOMContentLoaded', function() {
  // Only run if calculator is present on this page
  if (!document.getElementById('smr-ps')) return;

(function(){
var D={
  'mp158':{wh:158,o:'dc',lo:.97,hi:.98,note:'Native DC output — minimal conversion loss. Actual capacity slightly exceeds rated 158Wh.',sp:'mp158'},
  'x6':{o:'x6',cells:6,vnom:3.6,lo:.97,hi:.98,note:'Swappable 21700 / 18650 cells in 6-series. Enter the capacity of one cell above.',sp:'x6'},
  'el8-298':{wh:298,o:'dc',lo:.97,hi:.98,note:'PoE 48V native DC output.'},
  'el8-648':{wh:648,o:'dc',lo:.97,hi:.98,note:'PoE 48V native DC output.'},
  'peakdo-lp2':{wh:99,o:'dc',lo:.95,hi:.96,note:'DC direct output. Display draws a small additional load.'},
  'peakdo-lp1':{wh:96,o:'dc',lo:.95,hi:.96,note:'DC direct with LCD and Bluetooth. Display draws a small additional load.'},
  'ravion-99':{wh:99,o:'dc',lo:.97,hi:.98,note:'DC direct output, indicator lights only.'},
  'ravion-158':{wh:158,o:'dc',lo:.97,hi:.98,note:'DC direct output, indicator lights only.'},
  'anker737':{wh:87,o:'usbc',lo:.83,hi:.88,note:'USB-C PD. The large display and active electronics reduce usable runtime slightly.',sp:'anker737'},
  'baseus':{wh:74,o:'usbc',lo:.83,hi:.88,note:'USB-C PD output. Digital display draws a small additional load.'},
  'zendure':{wh:96,o:'usbc',lo:.83,hi:.88,note:'USB-C PD output. OLED display draws a small additional load.'},
  'jackery100':{wh:99,o:'usbc',lo:.83,hi:.88,note:'USB-C PD output. Display draws a small additional load.'},
  'anker-c300dc':{wh:288,o:'usbc',lo:.83,hi:.88,note:'Use USB-C to power Mini — the XT60 port is input only.'},
  'anker-c300x':{wh:288,o:'usbc',lo:.83,hi:.88,note:'USB-C PD output.'},
  'jackery300':{wh:288,o:'usbc',lo:.83,hi:.88,note:'USB-C PD output.'},
  'bluetti-eb3a':{wh:268,o:'usbc',lo:.83,hi:.88,note:'USB-C PD output.'},
  'bluetti-ac2a':{wh:204,o:'usbc',lo:.83,hi:.88,note:'USB-C PD output.'},
  'goalzero':{wh:95,o:'multi',opts:['usbc','ac'],lo:{usbc:.85,ac:.78},hi:{usbc:.90,ac:.85},notes:{usbc:'USB-C PD output.',ac:'AC requires two conversion stages (inverter + Mini adapter).'}},
  'ecoflow-r2':{wh:256,o:'multi',opts:['usbc','ac'],lo:{usbc:.85,ac:.78},hi:{usbc:.90,ac:.85},notes:{usbc:'USB-C PD output.',ac:'AC requires two conversion stages (inverter + Mini adapter).'}}
};
var OL={dc:'DC direct',usbc:'USB-C',ac:'AC output'};
var OE={dc:{lo:.97,hi:.98},usbc:{lo:.85,hi:.90},ac:{lo:.78,hi:.85}};
var IV={light:{w:20,l:'~20W'},typical:{w:28,l:'~28W'},heavy:{w:40,l:'~40W'}};
var st={mode:'preset',key:'',mOut:'',manWh:0,manO:'dc',manC:'wh',int:'typical'};

function g(id){return document.getElementById(id);}
function tog(el,grp,cls){grp.querySelectorAll('[role="button"],button').forEach(function(b){b.classList.remove('smr-on');});el.classList.add('smr-on');}

window.smrEntry=function(m,btn){
  st.mode=m;tog(btn,g('ct-entry'),'smr-on');
  g('smr-pw').classList.toggle('smr-hide',m!=='preset');
  g('smr-maw').classList.toggle('smr-hide',m==='preset');
  if(m==='preset'){st.key='';g('smr-ps').value='';clrMulti();}
  compute();
};

window.smrCase=function(c,btn){
  st.manC=c;tog(btn,g('ct-case'),'smr-on');
  ['cwh','cmv','cm'].forEach(function(x,i){g('smr-'+x).classList.toggle('smr-hide',['wh','mahv','mah'][i]!==c);});
  g('smr-wp').textContent='';st.manWh=0;smrMaCh();
};

window.smrPsCh=function(){
  var k=g('smr-ps').value;st.key=k;clrMulti();
  if(!k){compute();return;}
  var d=D[k];
  if(d.o==='x6'){
    g('smr-x6w').classList.remove('smr-hide');
    g('smr-pn').textContent=d.note||'';
  } else if(d.o==='multi'){
    g('smr-mw').classList.remove('smr-hide');
    var c=g('smr-mp');c.innerHTML='';
    d.opts.forEach(function(op,i){
      var b=document.createElement('button');
      b.className=i===0?'smr-on':'';b.textContent=OL[op];
      b.onclick=function(){
        c.querySelectorAll('button').forEach(function(x){x.classList.remove('smr-on');});
        b.classList.add('smr-on');st.mOut=op;
        g('smr-pn').textContent=d.notes?d.notes[op]:'';compute();
      };
      c.appendChild(b);
    });
    st.mOut=d.opts[0];g('smr-pn').textContent=d.notes?d.notes[d.opts[0]]:'';
  } else {g('smr-pn').textContent=d.note||'';}
  compute();
};

function clrMulti(){
  g('smr-mw').classList.add('smr-hide');
  g('smr-mp').innerHTML='';g('smr-pn').textContent='';st.mOut='';
  var x6=g('smr-x6w');if(x6)x6.classList.add('smr-hide');
}

window.smrMaOut=function(op,btn){
  st.manO=op;
  g('smr-op').querySelectorAll('[role="button"],button').forEach(function(x){x.classList.remove('smr-on');});
  btn.classList.add('smr-on');compute();
};

window.smrMaCh=function(){
  var wh=0,pv=g('smr-wp');
  if(st.manC==='wh'){wh=parseFloat(g('smr-wi').value)||0;pv.textContent='';}
  else if(st.manC==='mahv'){
    var m=parseFloat(g('smr-mi2').value)||0,v=parseFloat(g('smr-vi').value)||0;
    wh=m*v/1000;pv.textContent=wh>0?'= '+wh.toFixed(1)+' Wh':'';
  } else {
    var m2=parseFloat(g('smr-mi1').value)||0;
    wh=m2*3.7/1000;pv.textContent=wh>0?'≈ '+wh.toFixed(1)+' Wh':'';
  }
  st.manWh=wh;compute();
};

window.smrX6Ch=function(){compute();};

window.smrInt=function(k,card){
  st.int=k;
  ['smr-il','smr-it','smr-ih'].forEach(function(id){g(id).classList.remove('smr-on');});
  card.classList.add('smr-on');compute();
};

function params(){
  var wh=0,lo,hi,sp=null,perCell=null;
  if(st.mode==='preset'){
    var d=D[st.key];if(!d)return null;
    if(d.o==='x6'){
      var cell=parseFloat(g('smr-x6cell').value)||0;
      if(!cell)return null;
      wh=Math.round(cell*d.vnom*d.cells/1000*10)/10;
      perCell=Math.round(cell*d.vnom/1000*10)/10;
      return{wh:wh,lo:d.lo,hi:d.hi,sp:'x6',perCell:perCell};
    }
    wh=d.wh;sp=d.sp||null;
    if(d.o==='multi'){var op=st.mOut||d.opts[0];lo=d.lo[op];hi=d.hi[op];}
    else{lo=d.lo;hi=d.hi;}
  } else {
    wh=st.manWh;if(!wh)return null;
    lo=OE[st.manO].lo;hi=OE[st.manO].hi;
  }
  return{wh:wh,lo:lo,hi:hi,sp:sp,perCell:perCell};
}

function compute(){
  var p=params(),res=g('smr-res'),nr=g('smr-nr');
  // X6 live pack-total readout (updates as the cell value is typed)
  var x6active=st.mode==='preset'&&D[st.key]&&D[st.key].o==='x6';
  var x6p=g('smr-x6pack');
  if(x6p){
    if(x6active){
      var cv=parseFloat(g('smr-x6cell').value)||0;
      x6p.textContent=cv>0?('Pack total: '+(Math.round(cv*3.6*6/1000*10)/10)+' Wh · Output: DC direct'):'';
    } else {x6p.textContent='';}
  }
  if(!p){
    res.classList.add('smr-hide');nr.classList.remove('smr-hide');
    var x6n0=g('smr-x6note');if(x6n0)x6n0.classList.add('smr-hide');
    return;
  }
  var iv=IV[st.int];
  var uLo=p.wh*p.lo,uHi=p.wh*p.hi,hLo=uLo/iv.w,hHi=uHi/iv.w;
  g('smr-ro').textContent=hLo.toFixed(1)+' – '+hHi.toFixed(1)+' h';
  g('smr-rl').textContent=p.wh+'Wh × '+Math.round(p.lo*100)+'–'+Math.round(p.hi*100)+'% ÷ '+iv.w+'W = '+hLo.toFixed(1)+'–'+hHi.toFixed(1)+' h';
  g('smr-mu').textContent=uLo.toFixed(0)+'–'+uHi.toFixed(0)+' Wh';
  g('smr-me').textContent=Math.round(p.lo*100)+'–'+Math.round(p.hi*100)+'%';
  g('smr-md').textContent=iv.l;
  g('smr-aa').classList.toggle('smr-hide',p.sp!=='anker737');
  // Suppress the generic >100Wh airline alert for X6 — show the cell-level note instead
  g('smr-ab').classList.toggle('smr-hide',p.sp==='x6'||p.wh<=100);
  g('smr-mn').classList.toggle('smr-hide',p.sp!=='mp158');
  var x6n=g('smr-x6note');
  if(x6n){
    if(p.sp==='x6'){
      x6n.classList.remove('smr-hide');
      x6n.textContent='Each cell ≈ '+p.perCell+' Wh — under the 100Wh carry-on limit, so the cells can fly in carry-on. The pack total ('+p.wh+' Wh) is for runtime estimation only.';
    } else {x6n.classList.add('smr-hide');}
  }
  res.classList.remove('smr-hide');nr.classList.add('smr-hide');
}

compute();
})();

  // ── Attach event listeners (replaces inline onclick= attributes) ──

  // Entry toggle: Select a device / Enter manually
  var entryBtns = document.querySelectorAll('#ct-entry [role="button"]');
  if (entryBtns[0]) entryBtns[0].addEventListener('click', function(){ smrEntry('preset', this); });
  if (entryBtns[1]) entryBtns[1].addEventListener('click', function(){ smrEntry('manual', this); });

  // Case toggle: Wh / mAh+V / mAh only
  var caseBtns = document.querySelectorAll('#ct-case [role="button"]');
  if (caseBtns[0]) caseBtns[0].addEventListener('click', function(){ smrCase('wh', this); });
  if (caseBtns[1]) caseBtns[1].addEventListener('click', function(){ smrCase('mahv', this); });
  if (caseBtns[2]) caseBtns[2].addEventListener('click', function(){ smrCase('mah', this); });

  // Output type toggle: DC / USB-C / AC
  var outBtns = document.querySelectorAll('#smr-op [role="button"]');
  if (outBtns[0]) outBtns[0].addEventListener('click', function(){ smrMaOut('dc', this); });
  if (outBtns[1]) outBtns[1].addEventListener('click', function(){ smrMaOut('usbc', this); });
  if (outBtns[2]) outBtns[2].addEventListener('click', function(){ smrMaOut('ac', this); });

  // Usage intensity cards
  var il = document.getElementById('smr-il');
  var it = document.getElementById('smr-it');
  var ih = document.getElementById('smr-ih');
  if (il) il.addEventListener('click', function(){ smrInt('light', this); });
  if (it) it.addEventListener('click', function(){ smrInt('typical', this); });
  if (ih) ih.addEventListener('click', function(){ smrInt('heavy', this); });

  // Device select dropdown
  var ps = document.getElementById('smr-ps');
  if (ps) ps.addEventListener('change', smrPsCh);

  // Manual input fields — recalc on change
  ['smr-wi','smr-mi1','smr-mi2','smr-vi'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('input', smrMaCh);
  });

  // X6 single-cell capacity input — recalc on change
  var x6cell = document.getElementById('smr-x6cell');
  if (x6cell) x6cell.addEventListener('input', smrX6Ch);

});